import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createStructuredSelector } from 'reselect';
import StatisticsChart from './StatisticsChart';
import { actions } from './StatisticsChart.actions';
import {
    getData,
    getGroupBy,
    getDisabledGroupBy
} from './StatisticsChart.selectors';

const mapStateToPropsSelectors = createStructuredSelector({
    chartData: getData,
    groupBy: getGroupBy,
    disabledGroupBy: getDisabledGroupBy
});

const StatisticsChartComponent = connect(
    function mapStateToProps(state) {
        return {
            ...mapStateToPropsSelectors(state),
            loading: state.statistics.chart.loading,
            parameters: state.statistics.chart.parameters
        };
    },
    function mapDispatchToProps(dispatch) {
        return {
            clear: bindActionCreators(actions.clear, dispatch)
        };
    }
)(StatisticsChart);

export default StatisticsChartComponent;
